export default function () {
  const widgetName = 'cardWidgetThirdFeature';
  const widgetOpts = cardWidgetThirdFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,


    cardWidgetLoaded: function () {
      function removeAtt() {

        const iconContainer = `
          <div class="icon-line"></div>
          <div class="icon-card"></div>`

        const overlayBlur = `
          <div class="back-blur"></div>
          <div class="back-overlay"></div>`
        $(".moreButton").attr("target", "");
        $(".moreButton").attr("class", "button moreButton");
        $(iconContainer).appendTo("#cardWidgetThirdFeature .card-widget-item .image-container");
        $(overlayBlur).appendTo("#cardWidgetThirdFeature .card-widget-item .image-container");
      }
      removeAtt()
    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true
  });
}